import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-servicesoptions-included-popup",
  templateUrl: "./servicesoptions-included-popup.component.html",
  styles: [],
})
export class ServicesoptionsIncludedPopupComponent implements OnInit {
  constructor(public dialogRef: NgbActiveModal) {}

  ngOnInit(): void {}

  close() {
    this.dialogRef.close({ success: false });
  }
}
